'use client';
import { FullWidthImageProps } from './types';
import Media from 'components/shared/Media/Media';
import { toMediaAsset } from 'components/shared/Media/toMediaAsset';
import { cn, getColorway, getYMargins } from 'utils/styles';
import { getEntryNativeFields } from 'utils/entryNativeFields';

const FullWidthImage = (props: FullWidthImageProps) => {
  const { desktopImage, mobileImage, sectionName, renderAsFullBleed, color, margins } = getEntryNativeFields(props);

  return (
    <section
      {...(sectionName != null && { id: encodeURIComponent(sectionName) })}
      className={cn(getColorway(color), getYMargins(margins))}
      data-testid="full-width-image">
      <div className={renderAsFullBleed ? '' : 'content-wrapper'}>
        <Media
          media={desktopImage && toMediaAsset(desktopImage)}
          mobileMedia={mobileImage && toMediaAsset(mobileImage)}
          sizes={'100vw'}
          className="w-full h-auto max-w-full rounded-none object-contain"
        />
      </div>
    </section>
  );
};

export default FullWidthImage;
